// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"127e525b","977":"012765df"}[chunkId] + ".chunk.js";
};